import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import ServiceAPI from "../../../../service/ServiceAPI";
import { Box } from "@material-ui/core";
import Constants from "../../../../utils/Constants";
import InventoryImage from "../../../utils/InventoryImage";
import LoadingIndicator from "../../../utils/LoadingIndicator";
import { hasUserRole } from "../../../../utils/AuthUtils";

const useStyles = makeStyles({
  container: {
    width: '90%',
    margin: 'auto',
    marginTop: '1em'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  galleryImage: {
    margin: '1em'
  },
  media: {
    width: 300,
    height: 300
  },
  gallery: {
    display: 'flex',
    margin: 'auto',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }
});

const GalleryView = function(props) {
  console.assert(props.workflowViews);
  console.assert(props.setWorkflowView);
  console.assert(props.updateSelectedImage);
  console.assert(props.handleClick_assignImageToInventory);


  const classes = useStyles();
  const [gallery, setGallery] = useState(null);
  const [isEmbeddedForImageSelection, setIsEmbeddedForImageSelection] = useState(props?.handleClick_assignImageToInventory !== undefined);

  const isInventoryManager = hasUserRole(Constants.UserRole.InventoryManager);

  useEffect(()=>{
    ServiceAPI.InventoryGallery().getGallery().then((json) => {
      setGallery(json);
    });
  }, []);

/**
 * Sends the image to the edit view
 * @param {*} image 
 */
  const handleClick_editImage = (image) => {
    if (isEmbeddedForImageSelection) {
      props.handleClick_assignImageToInventory(image);
      return;
    }

    // Else is not embedded noraml process

    props.updateSelectedImage(image);
    props.setWorkflowView(props.workflowViews.EditImage);
  }

  /**
   * Delete the selected image from the gallery
   */
  const handleClick_deleteImage = (image) => {
    ServiceAPI.InventoryGallery().deleteImage(image.id).then((json) => {
      if (json !== true) {
        return;
      }
      
      // Remove the deleted image from the local state
      let tmp = [...gallery];
      let imageIndex = tmp.indexOf(image);
      tmp.splice(imageIndex, 1);
      setGallery(tmp);    
    })
  }

  /**
   * 
   * @param {*} image 
   */
  const renderImageCard = (image) => {
    return (
      <Card className={classes.galleryImage}>
        <CardActionArea onClick={() => isInventoryManager && handleClick_editImage(image) }>
          <InventoryImage base64Image={ image.image } alt={ image.description } />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h3">
              { image.description }
            </Typography>
          </CardContent>
        </CardActionArea>
        { 
          (!isInventoryManager || isEmbeddedForImageSelection) ? null : (
            <CardActions>
              <Button size="small" color="primary" onClick={() => handleClick_editImage(image) }>
                Edit
              </Button>
              <Button size="small" color="primary" onClick={() => {handleClick_deleteImage(image)}}>
                Delete
              </Button>
            </CardActions>
          )
        }
      </Card>
    );
  }

  /**
   * 
   * @returns 
   */
  const render = () => {
    return (
      <>
        <LoadingIndicator isOpen={gallery === null} />

        <Box className={classes.container}>
          { isInventoryManager && 
            <Box className={classes.actions}>
              <Button 
                size="large" 
                variant="contained" 
                color="primary" 
                onClick={ () => props.setWorkflowView(props.workflowViews.AddImage) }
              >
                Add Image
              </Button>
            </Box>
          }
          <Box className={classes.gallery}>
          {
            gallery === null ? null : (
              gallery.map((v) => {
                return renderImageCard(v);
              })
            )
          }
          </Box>
        </Box>
      </>
    );
  }

  return render();
}

export default GalleryView; 